import * as React from "react";
import { MediaQuery, Card } from "@grandvisionhq/common";
import { H2 } from "@grandvisionhq/iris-ui";
/* empty css                       */
const OrderListItemCard = ({ header, imagePath, labels, href, onClick, subtitle }) => {
  const { useIsPhone } = MediaQuery;
  const isPhone = useIsPhone();
  return /* @__PURE__ */ React.createElement(
    Card,
    {
      layout: isPhone ? "vertical" : "horizontal",
      href,
      onClick,
      "aria-label": labels.viewDetails,
      className: "order-list-item-card"
    },
    /* @__PURE__ */ React.createElement(
      Card.Image,
      {
        backgroundColor: "var(--color--shade-lightest)",
        alt: header,
        src: imagePath,
        className: "order-list-item-card__image"
      }
    ),
    /* @__PURE__ */ React.createElement(Card.Content, { center: true, variant: "link" }, /* @__PURE__ */ React.createElement(H2, { variant: "small" }, header), subtitle ? /* @__PURE__ */ React.createElement(Card.Text, { variant: "caption", color: "text-secondary" }, subtitle) : null)
  );
};
export {
  OrderListItemCard as default
};
//# sourceMappingURL=OrderListItemCard.js.map
